import React, { useEffect } from 'react';

import { Center } from '@mantine/core';
import { useIsInIframe } from 'hooks/use-is-in-iframe';

interface GuestVoiceBasedSmartAssistantPageWrapperProps {
  children: React.ReactNode;
}

export function GuestVoiceBasedSmartAssistantPageWrapper({ children }: GuestVoiceBasedSmartAssistantPageWrapperProps) {
  const isInIframe = useIsInIframe();

  // Make the whole application background transparent when in iframe
  useEffect(() => {
    if (isInIframe) document.body.style.background = 'transparent';
  }, [isInIframe]);

  return isInIframe ? (
    <Center w="100%" h="100%" bg="transparent" style={{ backgroundColor: 'transparent' }}>
      {children}
    </Center>
  ) : (
    <Center w="100svw" h="100svh">
      {children}
    </Center>
  );
}
